import BasicButton from "../../../components/Buttons/BasicButton";
import XsCont from "../../../components/containers/Xs";
import HeaderWithoutSignIn from "../../../components/headers/HeaderWithoutSignIn";
import { Box, Container, Typography } from "@mui/material";
import React from "react";

const PlanUpgradeCompletePage: React.FC = () => {
  const handleClickButton = () => {
    window.location.href = "/menu";
  };

  return (
    <>
      <HeaderWithoutSignIn />
      <Container maxWidth={"xl"}>
        <Box textAlign="center" mt={15}>
          <Typography variant="h5" gutterBottom>
            アップグレード完了
          </Typography>
        </Box>
        <Box mt={10} textAlign="center">
          <Typography variant="body1" gutterBottom>
            スタンダードプランにアップグレードをしました。
            <br />
            プラグインから機能をご確認ください。
          </Typography>
        </Box>
      </Container>
      <XsCont>
        <BasicButton onClick={handleClickButton} mt={10}>
          メニュー
        </BasicButton>
      </XsCont>
    </>
  );
};

export default PlanUpgradeCompletePage;
